import { useState, useEffect } from "react";
import { Avatar, Table } from "antd";
import { afGetCountries } from "../../../services/apiFootballService/endPoints/country";
import {
  fetchLeagues,
  fetchPlayersData,
} from "../../../services/apiFootballService/endPoints/players";
import { afGetSeasons } from "../../../services/apiFootballService/endPoints/seasons";
import { FSelect } from "../../commons/formFields/FSelect";
import SuperAdminContainer from "../SuperAdminContainer";
import { ScreenHeader } from "../../../CommonComponents";

const Data = () => {
  const [tableData, setTableData] = useState([]);
  const [country, setCountry] = useState("");
  const [league, setLeague] = useState("");
  const [season, setSeason] = useState("");
  const [countries, setCountries] = useState([]);
  const [leagues, setLeagues] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const rootEl = document.querySelector(":root");
    rootEl.style.setProperty("--main-color", "#000000");

    Promise.all([afGetCountries(), afGetSeasons()]).then(
      ([fetchedCountries, fetchedSeasons]) => {
        setCountries(fetchedCountries.map((c) => c.name));
        setSeasons(fetchedSeasons);
      }
    );
  }, []);

  // Fetch leagues when country or season changes
  useEffect(() => {
    if (country && season) {
      fetchLeagues(country, season).then((fetchedLeagues) => {
        setLeagues(fetchedLeagues);
      });
    }
  }, [country, season]);

  // Fetch players when all three filters are set
  useEffect(() => {
    if (country && season && league) {
      setIsLoading(true);
      fetchPlayersData(country, season, league).then((data) => {
        setTableData(data);
        setIsLoading(false);
      });
    }
  }, [country, season, league]);

  const handleAPIParamChange = (e) => {
    const { name, value } = e.target;
    if (name === "country") {
      setCountry(value);
      setLeague("");
    } else if (name === "season") {
      setSeason(value);
      setLeague("");
    } else if (name === "league") {
      setLeague(value);
    }
  };

  const columns = [
    {
      title: "Club Name",
      key: "clubName",
      className: "header-white",
      dataIndex: "clubName",
      render: (data, record) => (
        <div className="d-flex">
          {record.logo ? (
            <Avatar size="large" src={record.logo} />
          ) : (
            <Avatar size="large" style={{ backgroundColor: "#ff4040" }}>
              {`${data}`.charAt(0).toUpperCase()}
            </Avatar>
          )}
          <span style={{ marginLeft: 30, fontWeight: "bold" }}>{data}</span>
        </div>
      ),
    },
    {
      title: "Id",
      key: "clubId",
      className: "header-white",
      dataIndex: "clubId",
    },
  ];

  return (
    <SuperAdminContainer>
      <ScreenHeader title="Data" elementCount={tableData.length} />
      <div
        style={{
          marginTop: "2px",
          backgroundColor: "var(--primary-white-background)",
          padding: "8px 12px",
          display: "flex",
          gap: "12px",
        }}
      >
        <div>
          <FSelect
            value={country}
            onChange={handleAPIParamChange}
            dataList={countries}
            dataOnlyValue={true}
            style={{ color: "#ffffff", fontSize: 16, width: "200px" }}
            name="country"
            display="my-row"
            placeholder="Country"
            tabIndex="2"
          />
        </div>
        <div>
          <FSelect
            value={season}
            onChange={handleAPIParamChange}
            dataList={seasons}
            dataOnlyValue={true}
            style={{ color: "#ffffff", fontSize: 16, width: "200px" }}
            name="season"
            display="my-row"
            placeholder="Season"
            tabIndex="2"
          />
        </div>
        <div>
          <FSelect
            value={league}
            onChange={handleAPIParamChange}
            dataList={leagues}
            dataKey="league_id"
            dataValue="name"
            style={{ color: "#ffffff", fontSize: 16, width: "200px" }}
            name="league"
            display="my-row"
            placeholder="League"
            tabIndex="2"
          />
        </div>
      </div>

      <Table
        bordered
        loading={isLoading}
        columns={columns}
        dataSource={tableData}
        scroll={{ x: "max-content" }}
        rowKey={(record) => record.clubId}
        defaultExpandAllRows={true}
        expandedRowRender={(record) => {
          const childCols = [
            {
              title: "Name",
              key: "playerName",
              className: "header-white",
              dataIndex: "playerName",
              render: (data, rec) => (
                <div className="d-flex">
                  {rec.photo ? (
                    <Avatar size="large" src={rec.photo} />
                  ) : (
                    <Avatar size="large" style={{ backgroundColor: "#ff4040" }}>
                      {`${data}`.charAt(0).toUpperCase()}
                    </Avatar>
                  )}
                  <span style={{ marginLeft: 30, fontWeight: "bold" }}>
                    {data}
                  </span>
                </div>
              ),
            },
            {
              title: "ID",
              key: "playerId",
              className: "header-white",
              dataIndex: "playerId",
            },
          ];
          return (
            <Table
              bordered
              columns={childCols}
              className="table-backdrop"
              bodyStyle={{ backgroundColor: "#ffffff" }}
              dataSource={record.players || []}
              rowKey={(player) => player.playerId}
              pagination={false}
            />
          );
        }}
        bodyStyle={{
          fontSize: window.innerWidth > 500 ? "18px" : "12px",
          backgroundColor: "#ffffff",
        }}
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />
    </SuperAdminContainer>
  );
};

export default Data;
